import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip, ListItemIcon, Menu, MenuItem } from '@mui/material';
import {
  Check as CheckIcon,
  ExpandMore as ExpandIcon,
  PlaceOutlined as PlaceIcon,
} from '@mui/icons-material';

/**
 * The location the scanner is working at. Tapping it lists every location
 * plus "all locations"; the choice drives the stock headline and is the
 * default for use, add and new batches.
 */
export default function LocationChip({ locations, value, onChange }) {
  const { t } = useTranslation('inventory');
  const [anchor, setAnchor] = useState(null);
  const current = locations.find(l => l.stock_location_id === value);
  const options = [
    { id: null, name: t('inventory:scanner.location_all') },
    ...locations.map(l => ({ id: l.stock_location_id, name: l.name })),
  ];
  const open = e => setAnchor(e.currentTarget);

  return (
    <>
      <Chip
        data-testid="working-location"
        icon={<PlaceIcon />}
        label={current ? current.name : t('inventory:scanner.location_all')}
        aria-label={t('inventory:scanner.location_change')}
        variant="outlined"
        color="primary"
        onClick={open}
        onDelete={open}
        deleteIcon={<ExpandIcon />}
        sx={{ height: 40, fontSize: '0.95rem', fontWeight: 600, maxWidth: '100%' }}
      />
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {options.map(opt => (
          <MenuItem
            key={opt.id ?? 'all'}
            selected={opt.id === (current ? value : null)}
            onClick={() => { onChange(opt.id); setAnchor(null); }}
            sx={{ minHeight: 48 }}
          >
            <ListItemIcon>{opt.id === (current ? value : null) && <CheckIcon fontSize="small" />}</ListItemIcon>
            {opt.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
